import { format, parseISO } from "date-fns"

export default function getFormattedTime(date: string, timeFormat: 12 | 24): string {
  const formatString = timeFormat === 12 ? "hh:mm a" : "HH:mm"
  return format(parseISO(date), formatString)
}
